import { useContext, useState } from "react";
import { formatarDataCompleta } from "../../utils/functions";
import Button from "../../atoms/button";
import { getOrderAdapter } from "../../orders/orderAdapters";
import ToastContext from "../../../context/toastProvider";
import AuthContext from "../../../context/authProvider";
import LoadingOverlay from "../../atoms/loadingOverlay";
import ChevronIcon from "../../../img/chevronIcon";

const gradingAdapter = getOrderAdapter("grading");

const ProductComments = ({ productData, refresh, adapter = gradingAdapter }) => {

    const { goodToast, badToast } = useContext(ToastContext);
    const { user } = useContext(AuthContext);

    const [more, setMore] = useState(false);
    const [newComment, setNewComment] = useState("");
    const [loading, setLoading] = useState(false);

    const productComments = productData?.comments;
    const userComments = productData?.user?.comments;

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            submitComment();
        }
    }

    const handleNewComment = (value) => {
        if (value.length <= 300) {
            setNewComment(value);
        }
    }

    const submitComment = async () => {
        if (!newComment) {
            return null;
        }
        setLoading(true);
        const data = await adapter.comments.post(user?.token, productData?._id, newComment);
        if (data?.type !== "success") {
            badToast("Erro ao criar comentário");
            setLoading(false);
            return null;
        }
        goodToast("Comentário criado!");
        refresh();
    }

    if (!more) {
        return (
            <div className="border border-[#666] p-2 m-4 cursor-pointer bg-monao" onClick={() => setMore(!more)}>
                <div className="flex items-center gap-2 w-fit m-auto">
                    {
                        productComments?.length || userComments?.length ?
                            <div className="w-6 h-2 rounded-full animate-pulse"></div>
                            : null
                    }
                    <h2 className="text-center text-lg">Comentários</h2>
                    {
                        productComments?.length || userComments?.length ?
                            <div className="w-6 h-2 rounded-full animate-pulse"></div>
                            : null
                    }
                    <p className="text-sm mb-4 text-green-400">{productComments?.length || userComments?.length ? `[${productComments?.length + userComments?.length}]` : null}</p>
                    <div><ChevronIcon fill="#fff" width="30px" /></div>
                </div>
            </div>
        )
    }

    return (
        <div className="relative border border-[#666] p-2 m-4 bg-monao pb-10" onKeyDown={e => handleKeyDown(e)}>
            <h2 className="text-center text-lg mb-4">Comentários</h2>
            <div className="transform rotate-180 absolute top-2 right-2 cursor-pointer" onClick={() => setMore(false)}>
                <ChevronIcon fill="#d59106" width="30px" />
            </div>
            <div className="flex gap-4 w-2/3 m-auto">
            </div>
            <div className="h-[320px] mt-4 flex gap-4">
                <div className="flex-1 overflow-y-scroll">
                    <div className="border flex-1 mb-2 border-primary">
                        <p className="text-center text-primary">Do pedido</p>
                    </div>
                    {
                        productComments?.length ?
                            productComments?.map((c, i) => (
                                <div key={i} className="border border-primary bg-[#000] px-2 py-4 mb-2">
                                    <p className="mb-4 text-center">{formatarDataCompleta(c?.date)}</p>
                                    <p className="mb-4 text-center">{c?.text}</p>
                                </div>
                            ))
                            :
                            <p className="text-center text-[#666]">Nenhum comentário</p>
                    }
                    <div className="flex justify-center gap-4 px-4 my-4 mt-10">
                        <input className="w-full text-black px-2" type="text" value={newComment} onChange={e => handleNewComment(e.target.value)} />
                        <Button classes="bg-green-400 hover:bg-green-300" click={submitComment} disabled={newComment === ""}>Comentar</Button>
                    </div>
                </div>
                <div className="flex-1 overflow-y-scroll">
                    <div className="border flex-1 mb-2 border-primary">
                        <p className="text-center text-primary">Do usuário</p>
                    </div>
                    {
                        userComments?.length ?
                            userComments?.map((c, i) => (
                                <div key={i} className="border border-primary bg-[#000] px-2 py-4 mb-2">
                                    <p className="mb-4 text-center">{formatarDataCompleta(c?.date)}</p>
                                    <p className="mb-4 text-center">{c?.text}</p>
                                </div>
                            ))
                            :
                            <p className="text-center text-[#666]">Nenhum comentário</p>
                    }
                </div>
            </div>
            <LoadingOverlay loading={loading} />
        </div>
    )
}

export default ProductComments;
